export default "__VITE_ASSET__BvRG2$_9__"